import React, { useEffect, useState, useRef } from "react";
import useProductConfiguration from "../../../../../hooks/useProductConfiguration";

const SummaryValues = ({ config }) => {
  // Use config as the source of truth for rows
  const [rows, setRows] = useState(config || []);
  const { setUpdatedVariantConfigurations, updatedVariantConfigurations } =
    useProductConfiguration();
  const hasInitialized = useRef(false);

  // Debug logging
  console.log("SummaryValues - received config prop:", config);
  console.log("SummaryValues - current rows state:", rows);
  console.log(
    "SummaryValues - updatedVariantConfigurations from context:",
    updatedVariantConfigurations
  );

  useEffect(() => {
    // Only set initial config if we haven't initialized yet, or if there are no updated configurations
    if (!hasInitialized.current || updatedVariantConfigurations.length === 0) {
      console.log("SummaryValues - Setting rows to config:", config);
      setRows(config || []);
      hasInitialized.current = true;
    }
  }, [config, updatedVariantConfigurations]);

  // Update the provider whenever rows change
  useEffect(() => {
    if (rows.length > 0) {
      setUpdatedVariantConfigurations(rows);
    }
  }, [rows, setUpdatedVariantConfigurations]);

  return (
    <div className="bg-white border border-neutral-200 rounded-lg shadow-sm p-4">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-2xl font-semibold text-gray-900">
          Step 3 : Variants Summary
        </h2>
      </div>

      <div className="overflow-x-auto">
        <table className="w-full text-sm border-collapse">
          <thead>
            <tr className="bg-gray-50 text-gray-600 uppercase text-xs">
              <th className="px-4 py-3 text-left font-semibold">Name</th>
              <th className="px-4 py-3 text-left font-semibold">MRP Price</th>
              <th className="px-4 py-3 text-left font-semibold">
                Selling Price
              </th>
              <th className="px-4 py-3 text-left font-semibold">
                Business Selling Price
              </th>
              <th className="px-4 py-3 text-left font-semibold">Quantity</th>
              <th className="px-4 py-3 text-left font-semibold">Status</th>
              <th className="px-4 py-3 text-left font-semibold">Attributes</th>
            </tr>
          </thead>

          <tbody>
            {rows.map((r, idx) => (
              <tr key={idx} className="border-t hover:bg-gray-50">
                <td className="px-4 py-3 text-gray-900">{r.product_name}</td>
                <td className="px-4 py-3 text-gray-900">
                  <input
                    type="text"
                    value={r.mrp_price}
                    onChange={(e) => {
                      const value = e.target.value;
                      setRows((rows) =>
                        rows.map((row, i) =>
                          i === idx ? { ...row, mrp_price: value } : row
                        )
                      );
                    }}
                    placeholder="MRP Price"
                    className="border border-gray-300 rounded-md p-2 w-[100px]"
                  />
                </td>
                <td className="px-4 py-3">
                  <input
                    type="text"
                    value={r.selling_price}
                    onChange={(e) => {
                      const value = e.target.value;
                      setRows((rows) =>
                        rows.map((row, i) =>
                          i === idx ? { ...row, selling_price: value } : row
                        )
                      );
                    }}
                    placeholder="Selling Price"
                    className="border border-gray-300 rounded-md p-2 w-[100px]"
                  />
                </td>
                <td className="px-4 py-3">
                  <input
                    type="text"
                    value={r.business_selling_price || ""}
                    onChange={(e) => {
                      const value = e.target.value;
                      setRows((rows) =>
                        rows.map((row, i) =>
                          i === idx ? { ...row, business_selling_price: value } : row
                        )
                      );
                    }}
                    placeholder="Business Selling Price"
                    className="border border-gray-300 rounded-md p-2"
                  />
                </td>
                <td className="px-4 py-3">
                  <input
                    type="text"
                    value={r.quantity}
                    onChange={(e) => {
                      const value = e.target.value;
                      setRows((rows) =>
                        rows.map((row, i) =>
                          i === idx ? { ...row, quantity: value } : row
                        )
                      );
                    }}
                    placeholder="Quantity"
                    className="border border-gray-300 rounded-md p-2 w-[100px]"
                  />
                </td>
                <td className="px-4 py-3">
                  {r.status === "1" ? "Enabled" : "Disabled"}
                </td>
                <td className="px-4 py-3 text-gray-800">
                  {Array.isArray(r.attributes)
                    ? r.attributes.map((a) => a.attribute_value_name).join(", ")
                    : ""}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default SummaryValues;
